import React from 'react';
import { Form, Select } from 'antd';
import styled from '@emotion/styled';
import { selectSelector } from '../../../styles';

const { Option } = Select;

interface Options {
  value: string | number;
  text?: string;
}

interface SelectOptionProps {
  values: Options[];
  textDisplay?: 'value' | 'text';
  showSearch?: boolean;
  allowClear?: boolean;
  multiple?: boolean;
  placeholder?: string;
  defaultValue?: any;
  onChange?: (value: any) => void;
  modeForm?: boolean;
  rules?: any;
  name?: string;
  label?: string;
}

export const SelectOption = (props: SelectOptionProps) => {
  const {
    values,
    textDisplay,
    showSearch,
    allowClear,
    multiple,
    placeholder,
    defaultValue,
    onChange,
    modeForm,
    rules,
    name,
    label,
  } = props;
  const textDisplayOnPage = textDisplay || 'value';
  if (modeForm) {
    return (
      <Form.Item name={name} label={label} rules={rules}>
        <StyledSelectOption
          showSearch={showSearch}
          allowClear={allowClear}
          mode={multiple ? 'multiple' : undefined}
          placeholder={placeholder}
          onChange={onChange}
        >
          {values.map((item, index) => (
            <Option value={item.value} key={item.value}>
              {item[textDisplayOnPage]}
            </Option>
          ))}
        </StyledSelectOption>
      </Form.Item>
    );
  }
  return (
    <StyledSelectOption
      showSearch={showSearch}
      allowClear={allowClear}
      mode={multiple ? 'multiple' : undefined}
      defaultValue={defaultValue}
      placeholder={placeholder}
      onChange={onChange}
    >
      {values.map((item, index) => (
        <Option value={item.value} key={item.value}>
          {item[textDisplayOnPage]}
        </Option>
      ))}
    </StyledSelectOption>
  );
};

const StyledSelectOption = styled(Select)`
  ${selectSelector}
`;
